// extracted by mini-css-extract-plugin
export default {"dynamic-media-video":"js0Q4T2"};